import { ValidationErrorDetails } from '../validation-error-details';

export class FormInstanceValidatorParams {
  public instanceNumberTaken?: ValidationErrorDetails;
}
